module.exports = __webpack_public_path__ + "static/img/image2.dc88ac0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hackv1/image2.jpg
// module id = 97
// module chunks = 1